export enum ESubscriptionStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DEACTIVATED = 'deactivated',
    RETIRED = 'retired',
}
